function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5967 19.48C21.1807 19.48 23.0527 18.904 23.9887 18.088L22.9327 15.568C22.6447 15.904 22.0687 16.12 21.6607 16.12C20.9887 16.12 20.5807 15.832 20.2687 15.4L19.0447 13.552C18.6367 12.928 18.1087 12.472 17.5327 12.256V12.232C20.6767 11.632 22.5007 9.83196 22.5007 7.26396C22.5007 3.80796 19.8607 1.81596 15.2527 1.81596H0.804688V19H7.06869V13.288H10.7407C11.8687 13.288 12.9247 13.768 13.6447 14.776L14.7247 16.576C15.7087 17.992 17.0047 19.48 19.5967 19.48ZM7.06869 9.75996V5.51196H13.3807C15.1807 5.51196 16.2367 6.30396 16.2367 7.64796C16.2367 8.96796 15.1807 9.75996 13.3807 9.75996H7.06869Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.8197 19H43.1797V15.112H30.8917V11.92H41.9797V8.58396H30.8917V5.70396H42.9397V1.81596H24.8197V19Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9067 23.56L48.6507 22.936C46.5627 20.488 45.0747 15.904 45.0507 12.28C45.0267 8.53596 46.5147 3.97596 48.6507 1.47996L47.9067 0.855957C45.6507 3.35196 44.0667 8.17596 44.0907 12.28C44.1147 16.264 45.6987 21.112 47.9067 23.56Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59.6808 19.504C65.9928 19.504 70.0728 17.08 70.0488 13.528C70.0488 10.408 67.5528 8.82396 61.7448 8.22396L58.5528 7.88796C56.3448 7.67196 55.3848 7.26396 55.3848 6.61596C55.4088 5.70396 57.2088 5.12796 59.6568 5.10396C62.2968 5.07996 65.1288 5.87196 67.0008 7.11996L68.7528 3.51996C66.6408 2.15196 63.2328 1.28796 59.6088 1.28796C53.4888 1.28796 49.3128 3.37596 49.3128 7.07196C49.3128 10.12 51.6408 11.632 57.0648 12.208L60.2328 12.568C62.8488 12.856 63.9528 13.312 63.9528 14.056C63.9528 14.944 62.4168 15.52 59.9928 15.52C56.7048 15.52 52.9848 14.368 50.9928 12.784L48.8328 16.504C51.1368 18.28 55.5528 19.504 59.6808 19.504Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M83.5327 19.6C91.0927 19.6 96.1327 15.928 96.1327 10.408C96.1327 4.88796 91.0927 1.21596 83.5327 1.21596C75.9967 1.21596 70.9567 4.88796 70.9567 10.408C70.9567 15.928 75.9967 19.6 83.5327 19.6ZM83.5327 15.184C79.7647 15.184 77.2207 13.264 77.2207 10.408C77.2207 7.55196 79.7647 5.63196 83.5327 5.63196C87.3007 5.63196 89.8687 7.55196 89.8687 10.408C89.8687 13.264 87.3007 15.184 83.5327 15.184Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M108.547 19.432C115.507 19.432 119.587 16.456 119.587 11.08V1.81596H113.347V10.744C113.347 13.528 111.523 14.896 108.571 14.896C105.619 14.896 103.771 13.528 103.771 10.744V1.81596H97.5069V11.08C97.5069 16.456 101.611 19.432 108.547 19.432Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M140.179 19.48C141.763 19.48 143.635 18.904 144.571 18.088L143.515 15.568C143.227 15.904 142.651 16.12 142.243 16.12C141.571 16.12 141.163 15.832 140.851 15.4L139.627 13.552C139.219 12.928 138.691 12.472 138.115 12.256V12.232C141.259 11.632 143.083 9.83196 143.083 7.26396C143.083 3.80796 140.443 1.81596 135.835 1.81596H121.387V19H127.651V13.288H131.323C132.451 13.288 133.507 13.768 134.227 14.776L135.307 16.576C136.291 17.992 137.587 19.48 140.179 19.48ZM127.651 9.75996V5.51196H133.963C135.763 5.51196 136.819 6.30396 136.819 7.64796C136.819 8.96796 135.763 9.75996 133.963 9.75996H127.651Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M157.217 19.432C163.529 19.432 168.089 16.792 169.001 12.64L163.241 11.608C162.737 13.696 160.481 15.016 157.385 15.016C153.449 15.016 150.953 13.216 150.953 10.408C150.953 7.59996 153.185 5.79996 156.665 5.79996C159.137 5.79996 161.105 6.92796 161.681 8.72796L167.369 7.52796C166.217 3.75996 161.993 1.38396 156.497 1.38396C149.273 1.38396 144.689 4.88796 144.689 10.408C144.689 16.096 149.561 19.432 157.217 19.432Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M170.214 19H188.574V15.112H176.286V11.92H187.374V8.58396H176.286V5.70396H188.334V1.81596H170.214V19Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M189.677 23.56C192.077 20.872 193.469 16.264 193.493 12.28C193.517 8.17596 192.149 3.59196 189.653 0.855957L188.933 1.47996C191.285 4.23996 192.557 8.53596 192.533 12.28C192.509 15.904 191.189 20.248 188.933 22.936L189.677 23.56Z",
  fill: "black"
});

function SvgResourceBlackLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 24,
    viewBox: "0 0 194 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceBlackLogo);
export default __webpack_public_path__ + "static/media/resource-black-logo.d3a89bd5.svg";
export { ForwardRef as ReactComponent };